"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tapis Systems API
 * The Tapis Systems API provides for management of Tapis Systems including permissions, credentials and Scheduler Profiles.
 *
 * The version of the OpenAPI document: 1.0.0-rc1
 * Contact: cicsupport@tacc.utexas.edu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var CredentialsApi = /** @class */ (function (_super) {
    __extends(CredentialsApi, _super);
    function CredentialsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create or update credentials in the Security Kernel for given system and *target user* using a request body. Requester must be owner of the system. Credentials for multiple authentication methods may be provided.  Note that user making the request and *target user* may be different and frequently are different.  By default any credentials provided for LINUX type systems are verified. Use query parameter skipCredentialCheck=true to bypass initial verification of credentials.  Note that the attribute authnMethod is allowed but ignored so that the JSON result returned by a GET may be modified and used when making a POST to update credentials.
     * Create or update user credentials for a system and target user
     */
    CredentialsApi.prototype.createUserCredentialRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.systemId === null || requestParameters.systemId === undefined) {
                            throw new runtime.RequiredError('systemId', 'Required parameter requestParameters.systemId was null or undefined when calling createUserCredential.');
                        }
                        if (requestParameters.userName === null || requestParameters.userName === undefined) {
                            throw new runtime.RequiredError('userName', 'Required parameter requestParameters.userName was null or undefined when calling createUserCredential.');
                        }
                        if (requestParameters.reqCreateCredential === null || requestParameters.reqCreateCredential === undefined) {
                            throw new runtime.RequiredError('reqCreateCredential', 'Required parameter requestParameters.reqCreateCredential was null or undefined when calling createUserCredential.');
                        }
                        queryParameters = {};
                        if (requestParameters.skipCredentialCheck !== undefined) {
                            queryParameters['skipCredentialCheck'] = requestParameters.skipCredentialCheck;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/systems/credential/{systemId}/user/{userName}".replace("{" + "systemId" + "}", encodeURIComponent(String(requestParameters.systemId))).replace("{" + "userName" + "}", encodeURIComponent(String(requestParameters.userName))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.ReqCreateCredentialToJSON(requestParameters.reqCreateCredential),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespBasicFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create or update credentials in the Security Kernel for given system and *target user* using a request body. Requester must be owner of the system. Credentials for multiple authentication methods may be provided.  Note that user making the request and *target user* may be different and frequently are different.  By default any credentials provided for LINUX type systems are verified. Use query parameter skipCredentialCheck=true to bypass initial verification of credentials.  Note that the attribute authnMethod is allowed but ignored so that the JSON result returned by a GET may be modified and used when making a POST to update credentials.
     * Create or update user credentials for a system and target user
     */
    CredentialsApi.prototype.createUserCredential = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createUserCredentialRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Highly restricted. Only certain Tapis services authorized. Retrieve credentials for given system, *target user* and authentication method.  Note that user making the request and *target user* may be different and frequently are different.  Desired authentication method may be specified using query parameter authnMethod=<method>. If desired authentication method not specified then credentials for the system\'s default authentication method are returned.  The result includes the field authnMethod indicating the authentication method associated with the returned credentials.
     * Retrieve user credentials for a system and target user
     */
    CredentialsApi.prototype.getUserCredentialRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.systemId === null || requestParameters.systemId === undefined) {
                            throw new runtime.RequiredError('systemId', 'Required parameter requestParameters.systemId was null or undefined when calling getUserCredential.');
                        }
                        if (requestParameters.userName === null || requestParameters.userName === undefined) {
                            throw new runtime.RequiredError('userName', 'Required parameter requestParameters.userName was null or undefined when calling getUserCredential.');
                        }
                        queryParameters = {};
                        if (requestParameters.authnMethod !== undefined) {
                            queryParameters['authnMethod'] = requestParameters.authnMethod;
                        }
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/systems/credential/{systemId}/user/{userName}".replace("{" + "systemId" + "}", encodeURIComponent(String(requestParameters.systemId))).replace("{" + "userName" + "}", encodeURIComponent(String(requestParameters.userName))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespCredentialFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Highly restricted. Only certain Tapis services authorized. Retrieve credentials for given system, *target user* and authentication method.  Note that user making the request and *target user* may be different and frequently are different.  Desired authentication method may be specified using query parameter authnMethod=<method>. If desired authentication method not specified then credentials for the system\'s default authentication method are returned.  The result includes the field authnMethod indicating the authentication method associated with the returned credentials.
     * Retrieve user credentials for a system and target user
     */
    CredentialsApi.prototype.getUserCredential = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getUserCredentialRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Remove credentials from the Security Kernel for given system and *target user*. Requester must be owner of the system.  Note that user making the request and *target user* may be different and frequently are different.
     * Remove user credentials for a system and target user
     */
    CredentialsApi.prototype.removeUserCredentialRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.systemId === null || requestParameters.systemId === undefined) {
                            throw new runtime.RequiredError('systemId', 'Required parameter requestParameters.systemId was null or undefined when calling removeUserCredential.');
                        }
                        if (requestParameters.userName === null || requestParameters.userName === undefined) {
                            throw new runtime.RequiredError('userName', 'Required parameter requestParameters.userName was null or undefined when calling removeUserCredential.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/systems/credential/{systemId}/user/{userName}".replace("{" + "systemId" + "}", encodeURIComponent(String(requestParameters.systemId))).replace("{" + "userName" + "}", encodeURIComponent(String(requestParameters.userName))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespBasicFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Remove credentials from the Security Kernel for given system and *target user*. Requester must be owner of the system.  Note that user making the request and *target user* may be different and frequently are different.
     * Remove user credentials for a system and target user
     */
    CredentialsApi.prototype.removeUserCredential = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.removeUserCredentialRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return CredentialsApi;
}(runtime.BaseAPI));
exports.CredentialsApi = CredentialsApi;
